import dynamic from 'next/dynamic';
import {withAuthentication} from '../../js/components/Routes';

const AddInterviewPage = withAuthentication(
  dynamic(() => import('../../js/pages/AddInterviewPage'), {ssr: false}),
);

AddInterviewPage.getLayout = (page) => page;

export default AddInterviewPage;
